import jwtAuthService from "../../services/jwtAuthService";
import FirebaseAuthService from "../../services/firebase/firebaseAuthService";
import { setUserData } from "./UserActions";
import history from "@history.js";

export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const RESET_PASSWORD = "RESET_PASSWORD";

export function loginWithEmailAndPassword({ email_user, password }) {  
  return dispatch => {
    dispatch({
      type: LOGIN_LOADING
    });
    jwtAuthService    
    .loginWithEmailAndPassword(email_user, password)
    .then(user => {            
        dispatch(setUserData(user));

        // Si llegó al login desde una URL protegida (AuthGuard), vuelve a ella.
        const redirectUrl = history.location?.state?.redirectUrl;
        const safeRedirect =
          typeof redirectUrl === "string" &&
          redirectUrl.startsWith("/") &&
          !redirectUrl.startsWith("//") &&
          !redirectUrl.startsWith("/session");
        history.push({
          pathname: safeRedirect ? redirectUrl.split("?")[0] : "/",
          search: safeRedirect && redirectUrl.includes("?") ? `?${redirectUrl.split("?")[1]}` : "",
        });

        return dispatch({
          type: LOGIN_SUCCESS
        });
      })
      .catch(error => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error
        });
      });
  };
}

export function resetPassword({ email_user }) {
  return dispatch => {
    dispatch({
      payload: email_user,
      type: RESET_PASSWORD
    });
  };
}

export function firebaseLoginEmailPassword({ email_user, password }) {
  return dispatch => {
    FirebaseAuthService.signInWithEmailAndPassword(email_user, password)
      .then(user => {
        if (user) {
          dispatch(
            setUserData({
              userId: "1",
              role: "ADMIN",
              displayName: "Watson Joyce",
              email_user: "watsonjoyce@gmail.com",
              photoURL: "/assets/images/face-7.jpg",
              age: 25,
              token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh",
              ...user
            })
          );

          history.push({
            pathname: "/"
          });

          return dispatch({
            type: LOGIN_SUCCESS
          });
        } else {
          return dispatch({
            type: LOGIN_ERROR,
            payload: "Login Failed"
          });
        }
      })
      .catch(error => {
        return dispatch({
          type: LOGIN_ERROR,
          payload: error
        });
      });
  };
}
